import React, { useMemo } from 'react'
import styles from '../Home.module.less'
import { HeaderTabs } from 'Components/common/HeaderTabs/HeaderTabs'
import { AvailableExamsTab } from './exams/AvailableExamsTab'
import { HistoryTab } from './exams/HistoryTab'

export const ExamsTab: React.FC = () => {
    const tabItems = useMemo(
        () => [
            {
                key: 'available-exams',
                label: 'Available Exams',
                children: <AvailableExamsTab />,
            },
            {
                key: 'history',
                label: 'History',
                children: <HistoryTab />,
            },
        ],
        []
    )

    return (
        <div className={styles['exams-tab']}>
            <HeaderTabs items={tabItems} />
        </div>
    )
}
